module.exports = __webpack_public_path__ + "img/unchecked.4b3f6e85.svg";